(function() {
    const originalFetch = window.fetch;
    window.pmdFetch = originalFetch;

    /**
     * Interceptor configuration
     * Each entry: { pathname: "/cart/add.js", onRequest: fn, onResponse: fn }
     */
    const interceptors = [];

    /**
     * Add a new interceptor
     * @param {string} pathname - exact pathname to match (ignores query params)
     * @param {Function} onRequest - function(bodyObj, init) → modified bodyObj
     * @param {Function} onResponse - async function(data, response) → modified data
     */
    function addInterceptor(pathname, onRequest, onResponse) {
        interceptors.push({ pathname, onRequest, onResponse });
    }

    // Override fetch
    window.fetch = async function(input, init = {}) {
        const url = typeof input === 'string' ? new URL(input, window.location.origin) : new URL(input.url);
        const interceptor = interceptors.find(i => i.pathname === url.pathname);

        if (interceptor) {
            // Modify request body if JSON
            if (init.body && init.headers?.['Content-Type'] === 'application/json') {
                try {
                    let bodyObj = JSON.parse(init.body);
                    bodyObj = interceptor.onRequest ? interceptor.onRequest(bodyObj, init) : bodyObj;
                    init.body = JSON.stringify(bodyObj);
                    console.log('[Interceptor] Modified request body:', bodyObj);
                } catch (err) {
                    console.error('[Interceptor] Request parse error:', err);
                }
            }
        }

        // Perform original fetch
        const response = await originalFetch(input, init);

        if (interceptor && interceptor.onResponse) {
            try {
                const clone = response.clone();
                const data = await clone.json();
                const modified = await interceptor.onResponse(data, response);
                console.log('[Interceptor] Modified response data:', modified);

                // Return new Response if you want to override downstream
                return new Response(JSON.stringify(modified), {
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers
                });
            } catch (err) {
                console.error('[Interceptor] Response parse error:', err);
            }
        }

        return response;
    };

    // Expose helper
    window.addFetchInterceptor = addInterceptor;
})();

(function() {
    fetch('/cart.js').then(res => res.json()).then(data => window.cartData = data);


    async function removeFreeGift(data) {
        const promises = window.cartData.items
            .filter(line => line.properties._pmd_gift === 'true')
            .map(line => {
                return window.pmdFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: line.key,
                        quantity: 0
                    })
                }).then(res => res.json());
            });

        const results = await Promise.all(promises);

        if (results.length > 0)
            return results[results.length - 1];
        else
            return data;
    }

    async function updateSellingPlan(planId, data) {
        const promises = window.cartData.items
            .filter(line => line.properties._pmd_subscription_form === 'true' && line.selling_plan_allocation.selling_plan.id !== planId)
            .map(line => {
                return window.pmdFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: line.key,
                        quantity: line.quantity,
                        selling_plan: planId
                    })
                }).then(res => res.json());
            });

        const results = await Promise.all(promises);

        if (results.length > 0)
            return results[results.length - 1];
        else
            return data;
    }

    async function checkSellingPlans(data) {
        window.cartData = data;

        let quantity = window.cartData.items.reduce((acc, item) => {
            if (item.properties._pmd_subscription_form === 'true')
                return acc + item.quantity
            return acc
        }, 0);

        if (quantity === 0) {
            console.log('Removing free gift');
            return removeFreeGift(data);
        }

        if (quantity === 1) {
            console.log('Updating to one bag plan');
            return updateSellingPlan(691659145533, data);
        }

        if (quantity > 1) {
            console.log('Updating to two bag plan');
            return updateSellingPlan(691750043965, data);
        }

        return data;
    }
    // Intercept Shopify cart/add.js
    addFetchInterceptor(
        '/cart/change.js',
        (body) => {
            const item = window.cartData.items[body.line-1];
            if (item && item.properties._pmd_gift === 'true' && body.quantity !== 0)
                body.quantity = 1;

            return body;
        },
        checkSellingPlans
    );

    // Intercept another strict URL
    addFetchInterceptor(
        '/cart',
        (body) => {
            return body;
        },
        async (data) => {
            window.cartData = data;
            return data;
        }
    );
    if (location.pathname !== '/cart') return;

    fetch('/cart.js')
        .then(res => res.json())
        .then(data => {
            checkSellingPlans(data).then(result => {
                if (result && result !== data)
                    window.location.reload();
            })
        });
})();